'use strict';
////////

// config Modules
// It basically for keeping Constand Variable

///

export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

export const TIMEOUT_SEC = 10;

export const RES_PER_PAGE = 10;

export const KEY = '55d3fa9b-7332-43c7-b51d-4873c1bde754';

export const MODAL_CLOSE_SEC = 2.5;
